import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import EditOutlined from '@material-ui/icons/EditOutlined';
import Add from '@material-ui/icons/Add';
import Delete from '@material-ui/icons/Delete';
import NewAlert from './SaveAlert';
import './Alerts.css';
/**
 * @Description This function returns Alerts section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Alerts ({ state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [open, setOpen] = useState(false);

    const handleSave = (item, index) => {
        if (index > -1) {
            state.alerts[index] = item;
        } else {
            state.alerts.push(item);
        }
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
        setOpen(null);
    };

    const handleDelete = (index) => {
        state.alerts.splice(index, 1);
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
    };

    return (
        <div className="valerts">
            {state.alerts.length > 0 ?
                <div className="valert-list">
                    {state.alerts.map((item, index) =>
                        <div key={index} className="valert">
                            <div style={{ margin: 10 }}>{item.name}</div>
                            <div style={{ margin: 5 }}>
                                <IconButton size="small" onClick={() => handleDelete(index)} style={{ marginRight: 10 }}>
                                    <Delete fontSize="small" />
                                </IconButton>
                                <IconButton size="small" onClick={() => setOpen({ type: 'edit', item, index })} style={{ marginRight: 10 }}>
                                    <EditOutlined fontSize="small" />
                                </IconButton>
                            </div>
                        </div>
                    )}
                </div> :
                <div className="vno-alert">
                    {t(label + 'NO-ALERT')}
                </div>
            }
            <div className="vadd-alert">
                <button onClick={() => setOpen({ type: 'add' })}>
                    <Add fontSize="small" />{t(label + 'ADD-ALERT')}
                </button>
            </div>
            {open && <NewAlert open={open} setOpen={setOpen} onSave={handleSave} />}
        </div>
    );
}
export default Alerts;